import CampaignDataService from './CampaignDataService';

export default angular.module('edge.platform.campaign', [])
    .provider('CampaignDataService', CampaignDataService);